import React, {useState, useEffect, useContext} from 'react'
import { LoadingContext} from '../partials/Context';
import { getNavlinks } from '../functions/api';
import NavbarContent from './NavbarContent';
import WoltersNavbar from './WoltersNavbar';


function MainNavbar({simplified})  {
    const [navData, setNavData] = useState({});
    const {setLoading} = useContext(LoadingContext)
    useEffect(() => {
        setLoading(true);
        getNavlinks(setNavData, setLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    

    if (simplified) {
        return (<WoltersNavbar navData={navData}/>)
    } else {
        return(<NavbarContent navData={navData} />)
    }
}

export default MainNavbar;